module.exports = __webpack_public_path__ + "img/bg-0.b637f7f9.png";